import { render, staticRenderFns } from "./Object.vue?vue&type=template&id=10e85b82&scoped=true&"
import script from "./Object.vue?vue&type=script&lang=js&"
export * from "./Object.vue?vue&type=script&lang=js&"
import style0 from "./Object.vue?vue&type=style&index=0&id=10e85b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e85b82",
  null
  
)

export default component.exports